import classNames from "classnames";
import * as React from "react";
import { useState, useRef, useEffect } from "react";
import { CSSTransition } from "react-transition-group";

interface IAdvancedQueryDropdown {
    label: string;
    children: any;
    cssWrapper?: string;
    cssButton?: string; //className suffix for <button> element
    isOpen: boolean;
    togglePopUp: (v: boolean) => void;
}

export const AdvancedQueryDropdown = (props: IAdvancedQueryDropdown) => {
    const wrapperRef = useRef(null);

    const { label } = props;

    const handleClickOutside = () => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {props.togglePopUp(false);}
    };

    const ToggleDropdown = () => {
        props.togglePopUp(!props.isOpen);
    };

    useEffect(() => {
        document.addEventListener("touchstart", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={classNames("advanced-query", props.cssWrapper)} ref={wrapperRef}>
            <button
                className={classNames("trigger", props.cssButton)}
                onClick={() => ToggleDropdown()}
                aria-expanded={props.isOpen}
                aria-haspopup="true"
            >
                <span className="icon" aria-hidden={true} />
                <span className="text">{label}</span>
            </button>

            <CSSTransition in={props.isOpen} timeout={300} unmountOnExit classNames="a-dropdown">
                {/* {isOpen => ( */}
                <div className="dropdown-list mb-20" aria-hidden={!props.isOpen}>
                    <div className="dropdown-list-panel">{props.children}</div>
                </div>
                {/* )} */}
            </CSSTransition>
        </div>
    );
};
